import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getValue } from '../../../utils/utility/booking';
import './darkSelect.scss';

const Select = ({
  name,
  label,
  options,
  error,
  selectedValue,
  classname = '',
  heightStyle = '',
  theme = 'light',
  outSideLabel = false,
  labelPosition = 'inside',
  placeholder,
  outSideLabelClass = '',
  style = {
    height: heightStyle === 'noHeight' ? 'none' : '4rem',
    border: '1px solid rgb(189, 198, 243)',
    borderRadius: '1rem',
  },
  ...rest
}) => {
  return (
    //delete form-group and add mb-2
    <div className={`label-font-responsive ${classname} ${theme}-select-mode `}>
      {outSideLabel ? (
        labelPosition === 'top' ? (
          <div
            className={`text-dark px-3 d-flex w-100 justify-content-start align-items-center pb-2 ${outSideLabelClass}`}
            style={{ outline: 'none' }}
          >
            <FormattedMessage id={label} />
          </div>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
      {/* <label htmlFor={name}>{label}</label> */}
      <select
        {...rest}
        id={name}
        name={name}
        value={rest.value ? rest.value : selectedValue}
        className={`form-control m-0 w-100 d-flex  bg-third-light 
        ${error ? 'text-danger border-danger' : ''}
        `}
        style={style}
      >
        {placeholder && (
          <option
            value="defaultValue"
            disabled={selectedValue}
            style={{ fontFamily: 'Vazir' }}
          >
            {placeholder}
          </option>
        )}
        {options.data.map((option, index) => {
          if (options.optionGroup)
            return (
              <optgroup
                key={`opt-${index}`}
                className="d-flex bg-light p-2 text-muted "
                // label={getLodash(option, options.optionGroup)}
                label={getValue(option, options.optionGroup)}
              >
                {option[name].length > 0 &&
                  option[name].map((subOption) => (
                    <option
                      className="d-flex vazir"
                      key={subOption.id}
                      value={subOption[options.value]}
                    >
                      {/* {getLodash(subOption, options.showData)} */}
                      {getValue(subOption, options.showData)}
                    </option>
                  ))}
              </optgroup>
            );

          return (
            <option
              key={`${index}-${option[options.value]}`}
              value={option[options.value]}
            >
              {getValue(option, options.label)}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Select;
